export function BlobA(props) {
  return (
    <svg viewBox="0 0 600 600" fill="none" {...props} aria-hidden="true">
      <path
        d="M421 96c52 35 87 99 79 162-7 63-58 124-122 154-65 30-143 30-200-7-58-37-95-110-79-176C115 162 180 100 251 78c70-22 117-17 170 18Z"
        fill="#C86A4A"
        fillOpacity="0.22"
      />
    </svg>
  );
}
export function BlobB(props) {
  return (
    <svg viewBox="0 0 600 600" fill="none" {...props} aria-hidden="true">
      <path
        d="M120 230c10-90 110-160 220-150 110 10 200 90 200 200 0 110-100 200-220 200-130 0-210-160-200-250Z"
        fill="#7E9B86"
        fillOpacity="0.22"
      />
    </svg>
  );
}
export function BlobC(props) {
  return (
    <svg viewBox="0 0 600 600" fill="none" {...props} aria-hidden="true">
      <path
        d="M86 360c-16-110 70-220 200-250 130-30 270 50 290 170 20 120-90 230-220 240-130 10-254-50-270-160Z"
        fill="#F2D7B6"
        fillOpacity="0.55"
      />
    </svg>
  );
}

export function SoftLine({ className = "" }) {
  return (
    <svg
      viewBox="0 0 200 20"
      fill="none"
      className={className}
      aria-hidden="true"
      preserveAspectRatio="none"
    >
      <path
        d="M2 10 C 40 2, 80 18, 120 10 S 180 2, 198 10"
        stroke="#C86A4A"
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}
